import { CONFIGS_NAME } from '@/config/const';

const LOCALE_TYPES = {
  [CONFIGS_NAME.DEFAULT]: {
    RU: 'ru',
    EN: 'en',
  },
  [CONFIGS_NAME.TAMGA]: {
    RU: 'ru',
    KZ: 'kz',
    EN: 'en',
  },
  [CONFIGS_NAME.OVERSIGHT]: {
    RU: 'ru',
    EN: 'en',
  },
};

const configType = process.env.VUE_APP_CONFIG || CONFIGS_NAME.DEFAULT;
export const LOCALE_TYPE = LOCALE_TYPES[configType];

export const CURRENT_LOCALES = Object.values(LOCALE_TYPE);
